import React, { createContext, useContext, useEffect, useState } from "react";

const LocationContext = createContext({ isAllowed: false, loading: true });

export const LocationProvider = ({ children }) => {
  const [isAllowed, setIsAllowed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await fetch(
          "https://ipinfo.io/json?token=6feae57958238d"
        );
        const data = await response.json();
        const blockedCountries = ["MK", "RS"];
        setIsAllowed(!blockedCountries.includes(data.country));
      } catch (error) {
        setIsAllowed(false);
      } finally {
        setLoading(false);
      }
    };

    fetchLocation();
  }, []);

  return (
    <LocationContext.Provider value={{ isAllowed, loading }}>
      {children}
    </LocationContext.Provider>
  );
};

// Custom hook to use location status
export const useLocationAllowed = () => {
  return useContext(LocationContext);
};
